import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import BienDescriptif from "./BienDescriptif";
import { Box, Button, Grid, Paper, Typography } from "@mui/material";
import BackButton from "../Common/BackButton";

export default function DealRealEstate({ id, from, step }) {
	console.log("DealRealEstate", from, step);
	const [state, setState] = useState({ loaded: false, tunnel: false });
	useEffect(() => {
		fetch("/api/f37ab7f1a7284e1ebd053bcd35acb51f/" + id + "/1")
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						setState((state) => ({
							...state,
							...res.pld,
							loaded: true,
						}));

						break;
					case "err":
						break;
					default:
						break;
				}
			});
	}, []);
	if (state.loaded !== true) return;
	return (
		<div style="margin: 10px; margin-top: 30px;">
			<Grid container spacing={1}>
				<Grid item xs={12}>
					<Paper style="padding: 10px;">
						<Box display="flex" justifyContent="space-between" alignItems="center">
							<Box p={1}>
								<BackButton tooltip={"Revenir en arrière"} from={from} />
							</Box>
							<Box p={1}>
								<Typography variant="h5">Fiche du bien</Typography>
							</Box>
							<Box>
								<Button
									variant="contained"
									disabled={state.mandate_signed}
									onClick={() => {
										window.location.href = "/dre/" + state.deal_uid;
									}}
								>
									{state.other_assets !== undefined && Object.keys(state.other_assets).length > 0 ? "Voir tous les biens" : "Ajouter un bien"}
								</Button>
							</Box>
						</Box>
					</Paper>
				</Grid>
				<Grid item xs={12}>

					<Paper style="padding: 10px;">
						<BienDescriptif setUpperState={setState} upperState={state} tab={step} />
					</Paper>
				</Grid>
			</Grid>
		</div>
	);
}
